module.exports = __webpack_public_path__ + "media/images/twitter2x-a69a7a47d1451068060bb8fb50f0b1f0.png";